/**
 * Builds a minimal, valid flow document for the "Place a call" panel's quick
 * message mode: type a message, pick a registered voice, skip the designer
 * entirely. Reuses the exact same publish/place machinery every other flow
 * already goes through — this is a document-construction convenience, not a
 * new backend capability.
 */
export interface QuickMessageFlow {
  schema_version: string;
  id: string;
  direction: "inbound";
  start_node_id: string;
  variables: unknown[];
  nodes: Array<{ id: string; type: string; config: Record<string, unknown> }>;
  edges: Array<{ id: string; source: string; port: string; target: string }>;
}

export function buildQuickMessageFlow(text: string, voice: string, language: string): QuickMessageFlow {
  const id = "quick-message-" + crypto.randomUUID();
  return {
    schema_version: "1.0",
    id,
    direction: "inbound",
    start_node_id: "start",
    variables: [],
    nodes: [
      { id: "start", type: "start", config: {} },
      { id: "greet", type: "tts", config: { text, voice, language } },
      { id: "end", type: "hangup", config: { reason: "normal" } },
    ],
    edges: [
      { id: "e1", source: "start", port: "next", target: "greet" },
      { id: "e2", source: "greet", port: "next", target: "end" },
      { id: "e3", source: "greet", port: "error", target: "end" },
    ],
  };
}
